import http from "@/common/http-common";
//import store from "@/store";

class SiteService {
  getSites(company_uuid) {
    const thisHandle = this;
    return http().get("/api/v1/sites", { params: { company_id: company_uuid }}).then(function(resp) {
      console.log("Inside SiteService.getSites, resp.data ==> ", resp.data);
      const results = resp.data.map(function(result) {
        return thisHandle.mapAims2Site(result);
      });
      return results;
    })
  }

  getSite(site_uuid) {
    return http().get("/api/v1/sites/" + site_uuid, { responseType: 'json' }).then(function(resp) {
      console.log("Inside SiteService.loadAll, resp.data ==> ", resp.data);
      const site = this.mapAims2Site(resp.data);
      console.log("Inside SiteService.loadAll, site ==> ", site);
      return site;
    }.bind(this));
  }

  getPdf(site_uuid, locale) {
    return http().get("/api/v1/sites/" + site_uuid + ".pdf", { params: { locale: locale }, responseType: 'blob' }).then(function(resp) {
      console.log("Inside SiteService.loadAll, resp.data ==> ", resp.data);
      return resp.data;
    })
  }

  postSite(site) {
    const siteData = this.mapSite2Aims(site);
    
    return http().post("/api/v1/sites", {
      site: siteData,
      company_id: site.company_uuid
    }).then(function(resp) {
      console.log("Inside SiteService.postSite, resp ==> ", resp);
      return resp.data
    });
  }

  putSite(site) {
    const siteData = this.mapSite2Aims(site);
    
    return http().put("/api/v1/sites/" + site.uuid, {
      site: siteData,
      company_id: site.company_uuid
    }).then(function(resp) {
      console.log("Inside SiteService.putSite, resp ==> ", resp);
      return resp.data
    });
  }

  //destroySite(site) {
  //  
  //}

  mapSite2Aims(site) {
    return {
      uuid: site.uuid,
      name: site.name,
      desc: site.desc,
      address: site.address,
      city: site.city,
      province: site.province,
      post_code: site.post_code,
      country_code: site.country_code,
      long: site.long,
      lat: site.lat,
      map_zoom_level: site.map_zoom_level,
      nb_floors: site.nb_floors,
      area: site.area,
      area_unit_code: site.area_unit,
      year_built: site.year_built,
      occupancy_pcn: site.occupancy_pcn,
      weekly_op_hours: site.weekly_op_hours,
      primary_function: site.primary_function,
      site_function: site.site_function,
      updated_at: site.updated_at
    }
  }

  mapAims2Site(site) {
    return {
      aims_id: site.id,
      uuid: site.uuid,
      name: site.name,
      desc: site.desc,
      address: site.address,
      city: site.city,
      province: site.province,
      post_code: site.post_code,
      country_code: site.country_code,
      long: site.long,
      lat: site.lat,
      company_uuid: site.company_uuid,
      map_zoom_level: site.map_zoom_level,
      nb_floors: site.nb_floors,
      area: site.area,
      area_unit: site.area_unit_code,
      year_built: site.year_built,
      occupancy_pcn: site.occupancy_pcn,
      weekly_op_hours: site.weekly_op_hours,
      primary_function: site.primary_function,
      site_function: site.site_function,
      updated_at: site.updated_at
    }
  }  
}

export default new SiteService();